import styled from "styled-components"
import { DropdownButton, Dropdown } from "react-bootstrap"

export const ProfileDropdown = styled(DropdownButton)`
    display: flex;
    flex-direction: row;
    height: ${(props) => props.theme.layoutSizes.headerHeight}px;
    margin-left: 10px;

    & > .btn, & > .btn:active, & > .btn:focus, & > .btn:active:focus {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding-left: 30px;
        padding-right: 20px;
        border: 0;
        border-radius: 0;
        outline: none !important;
        box-shadow: none !important;
        background: ${(props) => props.theme.headerBackground};
        transition: 0.1s ease;

        &::after {
            content: "";
            display: block;
            border-top: 4px solid ${(props) => props.theme.profileTextColor};
            border-right: 4px solid transparent;
            border-bottom: 0;
            border-left: 4px solid transparent;
            position: absolute;
            left: 6px;
            top: 30px;
        }
    }

    &.show > .btn {
        background: ${(props) => props.theme.profileDropdownShowBackground};
        transition: 0.1s ease;
    }

    & > .dropdown-menu {
        width: 100%;
        box-sizing: border-box;
        padding: 0;
        border-radius: 0;
        transform: translate(0px, 63px) !important;
        border: 1px solid ${(props) => props.theme.profileDropdownMenuBackground};
        background: ${(props) => props.theme.profileDropdownMenuBackground};
    }
`
export const ProfileDropdownItem = styled(Dropdown.Item)`
    display: block;
    padding: 8px 24px;
    text-decoration: none;
    font-weight: 600;
    font-size: ${(props) => props.theme.fontSizes.md}px;
    font-family: ${(props) => props.theme.openSans};
    color: ${(props) => props.theme.profileDropdownMenuColor};
    background: transparent;
    transition: ${(props) => props.theme.defaultTransition};

    &:focus {
        outline: none;
        background: transparent;
        color: ${(props) => props.theme.profileDropdownMenuColor};
    }

    &:hover {
        text-decoration: none;
        color: ${(props) => props.theme.profileDropdownMenuHoverColor};
        background: ${(props) => props.theme.profileDropdownMenuHoverBackground};
        transition: ${(props) => props.theme.defaultTransition};
    }
`
export const ProfileInfo = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    max-width: 250px;
    margin-left: 20px;
    line-height: 19px;
    font-family: ${(props) => props.theme.defaultFont};
    font-size: ${(props) => props.theme.fontSizes.sm}px;
    color: ${(props) => props.theme.profileTextColor};

    & > span {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
`
export const ProfileInfoName = styled.span`
    font-weight: 700;
`
export const ProfileInfoAccount = styled.span`
`
